import availability from "./availability";
import availabilityForm from "./availabilityForm";
import explore from "./explore";
import form from "./form.json";
import language from "./language";
import product from "./product";
import productDiscovery from "./productDiscovery.json";

const namespaces = {
    availability,
    availabilityForm,
    language,
    product,
    productDiscovery,
    explore,
    form,
};

export default namespaces;
